import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-header-home',
    templateUrl: './header-home.component.html',
    styleUrls: ['./header-home.component.scss'],
    standalone: false
})
export class HeaderHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
